var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m76 0c-32.999 0-60 27.001-60 60s27.001 60 60 60 60-27.001 60-60-27.001-60-60-60z",
    fill: "#ff6c6c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m76 120c-41.4 0-76 33.6-76 75v47l28.001 30h98.699l24.3-30v-47c0-41.4-33.6-75-75-75z",
    fill: "#ff6c6c"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ff193d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m76 120v-120c32.999 0 60 27.001 60 60s-27.001 60-60 60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151 195v47l-24.3 30h-50.7v-152c41.4 0 75 33.6 75 75z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-32.999 0-60 27.001-60 60s27.001 60 60 60 60-27.001 60-60-27.001-60-60-60z",
    fill: "#ff6c6c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 120c-41.4 0-75 33.6-75 75v47l27.001 30h98.699l24.3-30v-47c0-41.4-33.6-75-75-75z",
    fill: "#ff6c6c"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ff193d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 120v-120c32.999 0 60 27.001 60 60s-27.001 60-60 60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331 195v47l-24.3 30h-50.7v-152c41.4 0 75 33.6 75 75z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m436 0c-32.999 0-60 27.001-60 60s27.001 60 60 60 60-27.001 60-60-27.001-60-60-60z",
    fill: "#ff6c6c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m436 120c-41.4 0-75 33.6-75 75v47l27.001 30h98.699l25.3-30v-47c0-41.4-34.6-75-76-75z",
    fill: "#ff6c6c"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ff193d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m436 120v-120c32.999 0 60 27.001 60 60s-27.001 60-60 60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 195v47l-25.3 30h-50.7v-152c41.4 0 76 33.6 76 75z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m0 242v15c0 140.7 115.3 255 256 255s256-114.3 256-255v-15z",
    fill: "#a8ebfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 242v15c0 140.7-115.3 255-256 255v-270z",
    fill: "#76e2f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.601 272c7.5 116.999 105.3 210 224.399 210s216.899-93.001 224.399-210z",
    fill: "#25d9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480.399 272c-7.5 116.999-105.3 210-224.399 210v-210z",
    fill: "#00c0f1"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#a8ebfa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m391 257c0 143.099-59.399 255-135 255s-135-111.901-135-255h30c0 122.1 47.999 225 105 225s105-102.9 105-225z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.1 362h415.8v30h-415.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241 257h30v240h-30z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m256 257h15v240h-15z",
    fill: "#76e2f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 362h207.9v30h-207.9z",
    fill: "#76e2f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391 257c0 143.099-59.399 255-135 255v-30c57.001 0 105-102.9 105-225z",
    fill: "#76e2f8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.9d73c5dffaa1de70d8b4e3b6ea64d098.svg";
export { ForwardRef as ReactComponent };